export default __webpack_public_path__ + "static/media/shuffle.efe3219f.mp3";